import { Banner, Text } from "@minuthq/meatball-ui-react"

import { EmailModeSelect } from "src/components/Account/BillingPortal/NotificationSettings/EmailModeSelect"
import { PushModeSelect } from "src/components/Account/BillingPortal/NotificationSettings/PushModeSelect"
import { useGetUser } from "src/data/user/hooks/useGetUser"
import { useFetchUserNotificationSettings } from "src/data/user/queries/userQueries"
import { TUserEventNotification } from "src/data/user/types/userTypes"
import { useTranslate } from "src/i18n/useTranslate"
import { GridTable } from "src/ui/GridTable/GridTable"
import {
  TableColumn,
  useTableColumns,
} from "src/ui/GridTable/useTableColumns/useTableColumns"

export function EventNotificationsSettings() {
  const { t, langKeys } = useTranslate()
  const user = useGetUser()

  const fetchUserSensorAlertNotificationSettings =
    useFetchUserNotificationSettings({
      userId: user.user_id,
      category: "sensor_alert",
    })

  const tableColumns: TableColumn<TUserEventNotification>[] = [
    {
      value: "label",
      label: t(langKeys.notifications_settings_events_column_header),
      renderCell: (notification) => (
        <div>
          <Text variant="subtitleS">{notification.label}</Text>
          <Text variant="bodyS" color="secondary">
            {notification.description}
          </Text>
        </div>
      ),
      columnWidth: "3fr",
    },
    {
      value: "push",
      label: t(langKeys.notifications_settings_events_column_header_app),
      renderCell: (notification) => {
        const channel = notification.channels.find(
          (channel) => channel.type === "push"
        )

        if (!channel) {
          return null
        }

        return (
          <div>
            <PushModeSelect notification={notification} channel={channel} />
          </div>
        )
      },
      columnWidth: "1fr",
    },
    {
      value: "email",
      label: t(langKeys.notifications_settings_events_column_header_email),
      renderCell: (notification) => {
        const channel = notification.channels.find(
          (notification) => notification.type === "email"
        )

        if (!channel) {
          return null
        }

        return (
          <div>
            <EmailModeSelect notification={notification} channel={channel} />
          </div>
        )
      },
      columnWidth: "1fr",
    },
  ]

  const { headerElements, rows, templateColumns } = useTableColumns({
    columns: tableColumns,
    data: fetchUserSensorAlertNotificationSettings.data?.events,
  })

  if (fetchUserSensorAlertNotificationSettings.isError) {
    return (
      <Banner type="error">
        {t(langKeys.failed_general_error_try_refreshing_page)}
      </Banner>
    )
  }

  return (
    <GridTable
      header={headerElements}
      rows={rows}
      mobileRows={rows}
      minWidth={0}
      templateColumns={templateColumns}
      disableRowHover
      horizontalScroll
      loading={fetchUserSensorAlertNotificationSettings.isLoading}
    />
  )
}
